import React, { useState } from "react";
import styles from "./LadowanieStrony.module.css";
import KropkiLadowania from "./KropkiLadowania";
import PasekPostepu from "./PasekPostepu";
import LicznikCzasu from "./LicznikCzasu";
import { useUplywCzasu } from "./czasLadowania";

/**
 * [S19 2026-09-14] ŁADOWANIE STRONY / SEKCJI — pasek u góry obszaru, skaczące kropki, napis i czas.
 *
 * Jeden komponent zamiast: kółka `PageLoader` w App.js (twarde kolory spoza motywu), rozmytej pełnoekranowej
 * nakładki w ProtectedRoute (sprawdzanie sesji) i lokalnych `.loadingState` + `.loadingSpinner` na podstronach.
 * Kontener ogłasza stan (`role="status"`), kropki i pasek są ozdobą — czytnik słyszy „Ładowanie…” raz.
 *
 * @param {object} props
 * @param {string} [props.etykieta="Ładowanie…"] widoczny napis (testy wielu ekranów szukają „Ładowanie…”)
 * @param {"ekran"|"strona"|"sekcja"|"wiersz"} [props.wariant="strona"]
 *        ekran — cały widok (sprawdzanie sesji przed układem); strona — obszar treści (trasa leniwa);
 *        sekcja — karta/panel; wiersz — w linii, bez wysokości minimalnej
 * @param {boolean} [props.bezPaska=false] bez paska postępu (np. mały panel, w którym pasek byłby szumem)
 * @param {string} [props.className]
 */
const LadowanieStrony = ({ etykieta = "Ładowanie…", wariant = "strona", bezPaska = false, className = "" }) => {
    const [startedAt] = useState(() => Date.now());
    const uplyw = useUplywCzasu(startedAt);

    const klasy = [styles.kontener, styles[wariant] || styles.strona, className].filter(Boolean).join(" ");

    return (
        <div className={klasy} role="status" aria-live="polite" aria-busy="true" data-ladowanie-strony={wariant}>
            {!bezPaska && wariant !== "wiersz" && (
                <PasekPostepu aktywny uplywMs={uplyw} className={styles.pasek} />
            )}
            <KropkiLadowania rozmiar={wariant === "wiersz" ? "sm" : "lg"} ozdobne />
            <span className={styles.etykieta}>{etykieta}</span>
            <LicznikCzasu uplywMs={uplyw} className={styles.licznik} />
        </div>
    );
};

export default LadowanieStrony;
